import { render } from "./BLY.vue?vue&type=template&id=1175cc9a&scoped=true"
import script from "./BLY.vue?vue&type=script&lang=js"
export * from "./BLY.vue?vue&type=script&lang=js"

import "./BLY.vue?vue&type=style&index=0&id=1175cc9a&lang=css"
import "./BLY.vue?vue&type=style&index=1&id=1175cc9a&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1175cc9a"]])

export default __exports__